import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { jsx as _jsx } from "react/jsx-runtime";
/*global $*/

import React from "react"; //courtesy https://stackoverflow.com/questions/32553158/detect-click-outside-react-component

/**
 * A kind of modal alert which supports closing by clicking outside
 */

var OutsideAlerter =
/** @class */
function (_super) {
  __extends(OutsideAlerter, _super);

  function OutsideAlerter(props) {
    var _this = _super.call(this, props) || this;

    _this.myRef = /*#__PURE__*/React.createRef();
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    return _this;
  }

  OutsideAlerter.prototype.componentDidMount = function () {
    $(document).on("mousedown.outsidealert.fht360", this.handleClickOutside);
  };

  OutsideAlerter.prototype.componentWillUnmount = function () {
    $(document).off("mousedown.outsidealert.fht360", this.handleClickOutside);
  };
  /**
   * Alert if clicked on outside of element
   */


  OutsideAlerter.prototype.handleClickOutside = function (e) {
    var ref = this.myRef.current;

    if (ref && !ref.contains(e.target)) {
      this.props.onClickedOutside();
    }
  };

  OutsideAlerter.prototype.render = function () {
    return _jsx("div", __assign({
      ref: this.myRef,
      className: this.props.className
    }, {
      children: this.props.children
    }), void 0);
  };

  return OutsideAlerter;
}(React.Component);

export default OutsideAlerter;